import React from 'react';
import PropTypes from 'prop-types';
import { designSystem } from '@yola/ws-ui';

const { ToggleSection, Stack, Box } = designSystem;

function ToggleableSection({ title, value, popover = null, onChange, children }) {
  return (
    <Box
      paddingTop="spacing-xs"
      paddingBottom={value ? 'spacing-s' : 'spacing-xs'}
      paddingLeft="spacing-m"
      paddingRight="spacing-m"
    >
      <ToggleSection
        value={value}
        title={title}
        {...(popover && { popoverProps: popover })}
        onChange={onChange}
      >
        <Stack gap="spacing-2-xs">{children}</Stack>
      </ToggleSection>
    </Box>
  );
}

ToggleableSection.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.bool.isRequired,
  popover: PropTypes.shape({
    title: PropTypes.string.isRequired,
    imgSrc: PropTypes.string,
  }),
  onChange: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};

export default ToggleableSection;
